import { render } from "./CashierSelectedElement.vue?vue&type=template&id=013f04cc&scoped=true"
import script from "./CashierSelectedElement.vue?vue&type=script&lang=js"
export * from "./CashierSelectedElement.vue?vue&type=script&lang=js"

import "./CashierSelectedElement.vue?vue&type=style&index=0&id=013f04cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013f04cc"]])

export default __exports__